import './colors/index.js';
import './controls/index.js';
import './icons/index.js';
import Colors from './colors/Colors.js';
import Controls from './controls/Controls.js';
import Icons from './icons/Icons.js';

class Theme {
  constructor(options = {}, base) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    this.options = options;
    this.colors = new Colors(options.colors, base === null || base === void 0 ? void 0 : base.colors);
    this.controls = new Controls(options.controls, base === null || base === void 0 ? void 0 : base.controls);
    this.icons = new Icons(options.icons, base === null || base === void 0 ? void 0 : base.icons);
    this.supplyVersion = (_b = (_a = options === null || options === void 0 ? void 0 : options.supplyVersion) !== null && _a !== void 0 ? _a : base === null || base === void 0 ? void 0 : base.supplyVersion) !== null && _b !== void 0 ? _b : 0;
    this.themeVersion = (_d = (_c = options === null || options === void 0 ? void 0 : options.themeVersion) !== null && _c !== void 0 ? _c : base === null || base === void 0 ? void 0 : base.themeVersion) !== null && _d !== void 0 ? _d : 0;
    this.logoLightImage = (_f = (_e = options === null || options === void 0 ? void 0 : options.logoLightImage) !== null && _e !== void 0 ? _e : base === null || base === void 0 ? void 0 : base.logoLightImage) !== null && _f !== void 0 ? _f : '';
    this.logoDarkImage = (_h = (_g = options === null || options === void 0 ? void 0 : options.logoDarkImage) !== null && _g !== void 0 ? _g : base === null || base === void 0 ? void 0 : base.logoDarkImage) !== null && _h !== void 0 ? _h : '';
    this.logoLightImageFileType = (_k = (_j = options === null || options === void 0 ? void 0 : options.logoLightImageFileType) !== null && _j !== void 0 ? _j : base === null || base === void 0 ? void 0 : base.logoLightImageFileType) !== null && _k !== void 0 ? _k : '';
    this.logoDarkImageFileType = (_m = (_l = options === null || options === void 0 ? void 0 : options.logoDarkImageFileType) !== null && _l !== void 0 ? _l : base === null || base === void 0 ? void 0 : base.logoDarkImageFileType) !== null && _m !== void 0 ? _m : '';
  }
  toVuetifyOptions() {
    return {
      themes: this.colors.toVuetifyOptions(),
      options: {
        customProperties: true
      }
    };
  }
  install() {
    this.colors.install();
  }
  installLocal(className) {
    this.colors.installLocal(className);
  }
  uninstall() {
    this.colors.uninstall();
  }
}

export { Theme as default };
